import { ChatRoomMessageChannel } from '@commenda/prisma';
import { fetcher, throwApiError } from '@commenda/utils';

export async function resumeChatRoomAgent(
  chatRoomId: string,
  channel: ChatRoomMessageChannel
): Promise<void> {
  const res = await fetcher(`chatRoom/${chatRoomId}/agent/resume`, {
    method: 'POST',
    body: { channel },
  });

  if (!res.ok) {
    await throwApiError(
      res,
      'Commenda Agent could not be resumed. Try again in a moment.'
    );
  }
}
